export default function useConditionalTranslation(item, displayOriginal = false) {
  return useShouldTranslate(item, displayOriginal) ? item.translation.content : item.content.getMessageText();
}

export function useShouldTranslate(item, displayOriginal = false) {
  return item.translation?.content && !displayOriginal;
}
